import api from './index';
import { handleGetAllData } from './utils';
const endpoints = {
    rallies: '/admin/rallies',
    getThemes: '/admin/themes',
    getGeographicAreas: '/admin/geographic-areas',
    getTargetGroups: '/admin/target-groups',
    saveRally: '/admin/rallies',
};
export const getAdminRallies = async () => {
    const res = await api.get(endpoints.rallies);
    return handleGetAllData(res);
};
export const getAdminRally = async (id) => {
    const res = await api.get(`${endpoints.rallies}/${id}`);
    return res.data;
};
export const getAdminRalliesThemes = async () => {
    const res = await api.get(endpoints.getThemes);
    return handleGetAllData(res);
};
export const getAdminRalliesGeographicAreas = async () => {
    const res = await api.get(endpoints.getGeographicAreas);
    return handleGetAllData(res);
};
export const getAdminRalliesTargetGroups = async () => {
    const res = await api.get(endpoints.getTargetGroups);
    return handleGetAllData(res);
};
export const saveAdminRally = async (body) => {
    return await api.post(endpoints.rallies, body);
};
export const updateAdminRally = async (id, body) => {
    const res = await api.patch(`${endpoints.rallies}/${id}`, body);
    return res.data;
};
export const deleteAdminRally = async (id) => {
    await api.delete(`${endpoints.rallies}/${id}`);
};
export const activateAdminRally = async (id) => {
    const res = await api.post(`${endpoints.rallies}/${id}/active`);
    return res.data;
};
